import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { TQC2050_R01Dto, TQC2050_R01DetailDto, TQC2050_R01HeaderDto } from "./Dto_TQC2050_R01";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { TQC2050_R01Filter } from "./Store_TQC2050_R01";

const itemUrl = `${config.apiUrl}/TQC2050_R01`;


// 검색 리스트: /search
export const getTQC2050_R01Search = async (params: Partial<TQC2050_R01Filter>) => {
    const url = `${itemUrl}/search`;
    return await getData<ResponseDto<TQC2050_R01HeaderDto[]>>(url, { params });
}

export const getTQC2050_R01AllCount = async (params: Partial<TQC2050_R01Filter>) => {
    const url = `${itemUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, {
        params: {
            ...params
        }
    });
}	

export const getTQC2050_R01One = async (testResultNo: string) => {
    const url = `${itemUrl}/detail/${testResultNo}`;
    return await getData<ResponseDto<TQC2050_R01HeaderDto & { testDetails: TQC2050_R01DetailDto[] }>>(url);
}


export const createTQC2050_R01 = async (data: TQC2050_R01Dto) => {
    const request = toTqcTestRequest(data);
    return await postData<TqcTestRequest, ResponseDto<TQC2050_R01HeaderDto>>(itemUrl, request);
}

export const patchTQC2050_R01 = async (data: TQC2050_R01Dto) => {
    const request = toTqcTestRequest(data);
    return await patchData<TqcTestRequest, ResponseDto<TQC2050_R01HeaderDto>>(itemUrl, request);
}

interface TqcTestRequest extends TQC2050_R01HeaderDto {
    testDetails: TQC2050_R01DetailDto[];
}

const toTqcTestRequest = (data: TQC2050_R01Dto): TqcTestRequest => ({
    ...data.tqcTestHeaderDto,
    testDetails: data.tqcTestDetailDtoList,
});

export const deleteTQC2050_R01 = async (testResultNo: string) => {
    const url = `${itemUrl}/${testResultNo}`;
    return await deleteData<ResponseDto<any>>(url);
}

export const downloadExcel_TQC2050_R01 = async (params: Partial<TQC2050_R01Filter>) => {
    const url = `${itemUrl}/excel/search`;
    return await getData<ResponseDto<string>>(url, { params });
}

// TQC 시험성적서 PDF 인쇄
export const printTQC2050_R01 = async (testResultNo: string) => {
    const url = `${itemUrl}/print`;
    return await getData<Blob>(url, { 
        params: { testResultNo },
        responseType: 'blob' // PDF 파일을 위한 blob 응답 타입
    });
}
